import React from 'react';
import InputTitleView from './InputTitleView';

const SuffixTextInputView = ({ title = '', required = false, subTitle = '', placeholder, isSmall = false, name, value, onChange, suffix = '' }) => {
  return (
    <div className="recruitment-suffix-text-input-view">
      <InputTitleView title={title} required={required} subTitle={subTitle} />
      <div className={`recruitment-suffix-text-input-view-input-wrapper ${isSmall && 'small'}`}>
        <input type="text" placeholder={placeholder} name={name} value={value} onChange={({ target }) => onChange({ name: target.name, value: target.value })} />
        <div className="recruitment-suffix-text-input-view-input-suffix">{suffix}</div>
      </div>
    </div>
  );
};

export default SuffixTextInputView;
